import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const WebDesignDevelopment = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Web Design & Development" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/it-development-consulting',
                            'text':'IT Development & Consulting'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Web Design & Development</h2>
                        <h3>Transform Your Brand Into Visual Story</h3>
                        <p>Web design is the first impression that you make with your potential customer. A centralized channel for all kinds of marketing activities. Make it alluring, functional, & dynamic</p>
                        <h3>We Design Experiences</h3>
                        <p>Web design is all about experiences that enhance the brand value. We design experiences that help you communicate with the users.</p>
                        <div className="row mt-5">
                            <div className="col-md-6">
                                <h3>Services</h3>
                                <ul>
                                    <li>Web Designing</li>
                                    <li>Website Redesigning</li>
                                    <li>Domain Registration</li>
                                    <li>Web Hosting</li>
                                    <li>Content Management Services</li>
                                    <li>Payment Gateway Integration Services</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>Roadmap To Development</h3>
                                <h3>UX Research</h3>
                                <p>Data driven insights for design strategy</p>
                                <ul>
                                    <li>Determine UX metrics</li>
                                    <li>Consider social implications</li>
                                    <li>Scalability prospect</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>UX/UI Design</h3>
                                <p>Adopting a product and design functionality that aligns with client objectives and end user behaviour</p>
                                <ul>
                                    <li>User Journey</li>
                                    <li>Wireframes</li>
                                    <li>Prototypes</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <h3>Develop</h3>
                                <p>Translate the design into an innovative product for use across all platforms</p>
                                <ul>
                                    <li>Front End Development</li>
                                    <li>Web Application</li>
                                    <li>Mobile Application</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default WebDesignDevelopment;